import * as React from 'react'


export default class FTCModal extends React.PureComponent<{
  onClose: () => void
}> {

  render() {
    const { onClose } = this.props

    return (
      <div className="modal privacy-modal">
        <div className="modal-content">

          <h1>FTC Disclosure</h1>

          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde tempora saepe id! Dolor porro, corrupti eius blanditiis veritatis exercitationem quo, nostrum provident, eaque recusandae unde dolorem! Accusantium recusandae mollitia similique.</p>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde tempora saepe id! Dolor porro, corrupti eius blanditiis veritatis exercitationem quo, nostrum provident, eaque recusandae unde dolorem! Accusantium recusandae mollitia similique.</p>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde tempora saepe id! Dolor porro, corrupti eius blanditiis veritatis exercitationem quo, nostrum provident, eaque recusandae unde dolorem! Accusantium recusandae mollitia similique.</p>

          <button className="modal-close" onClick={onClose}>&times;</button>

        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/comp/ftc-modal.tsx